module.exports = "<div class=\"q-pill q-pill-table rr-table-status-text {%- pillClassName %}\"> {%- value %} </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/returnsRules/html/rulesStatusPill.html
// module id = 1415
// module chunks = 1